<fs-dialog>
  <fs-dialog-title [close]="true">
    Notifications
  </fs-dialog-title>
  <mat-dialog-content>
    <fs-list [config]="config">
      <fs-list-column>
        <ng-template
            fs-list-cell
            let-row="row">
          <div class="fs-row.gap-sm">
            <div
                class="avatar"
                (click)="openObject(row)">
              <div
                class="status"
                (click)="toggleNotification($event, row, row.read)"
                [ngClass]="{ read: row.read }">
              </div>
              <fs-badge
                [size]="35"
                shape="circle"
                [image]="row.project.avatar?.tiny">
              </fs-badge>
            </div>
            <div class="details">
              @if (row.message) {
                <a
                    class="message"
                    (click)="openObject(row)">
                  {{ row.message }}
                </a>
              }
              <div class="identifier small">
                <app-object-identifier
                  [identifier]="row.object.identifier"
                  [name]="row.object.name"
                  [size]="'tiny'">
                </app-object-identifier>
                <span class="middot">
                  ·
                </span>
                <fs-date-ago [date]="row.createDate"></fs-date-ago>
              </div>
            </div>
          </div>
        </ng-template>
      </fs-list-column>
    </fs-list>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <button
        mat-button
        (click)="markReadAll()">
      Mark all as read
    </button>
  </mat-dialog-actions>
</fs-dialog>